import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { registerSW } from 'virtual:pwa-register'
import ErrorBoundary from '@components/layout/ErrorBoundary'
import AppRouter from './AppRouter.jsx'
import { ThemeProvider } from '@context/ThemeContext'
import { SoundProvider } from '@context/SoundContext.jsx'
import { AnimationsProvider } from '@context/AnimationsContext.jsx'
import '@styles/index.css'

registerSW({
  onNeedRefresh () {
    window.dispatchEvent(new CustomEvent('sw-update'))
  },
  onOfflineReady () {
    console.log('[PWA] App ready to work offline')
  }
})

function RootWrapper () {
  return <AppRouter />
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <ErrorBoundary>
      <ThemeProvider>
        <SoundProvider>
          <AnimationsProvider>
            <RootWrapper />
          </AnimationsProvider>
        </SoundProvider>
      </ThemeProvider>
    </ErrorBoundary>
  </StrictMode>
)
